import React, { useState, createContext } from "react";

export const ShopErrorContext = createContext()

export const ShopErrorContextProvider = (props) => {
  const [shopError, setShopError] = useState(false);

  return (
    <ShopErrorContext.Provider
      value={{
        shopError, setShopError
      }}
    >
      {props.children}
    </ShopErrorContext.Provider>
  )
}